import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Banner, Card, Form } from '@shopify/polaris';
import PolarisFormProvider from '@container/PolarisFormProvider';

import TableForm from './TableForm';
import TableRowsForm from './TableRowsForm';
import FormPageActions from '@container/FormPageActions';
import { FieldArray } from 'formik';

import PolarisLabel from '@presentational/AppLabel';
import TagsInput from 'react-tagsinput';
import { tAttribute } from '@utils';

// import { SectionSchema } from 'utils/validationSchemas';

import { Map, List } from 'immutable'
import { render } from 'react-dom';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  destroyURL: PropTypes.string,
  record: PropTypes.object,
  method: PropTypes.string, // HTML form method
}

const defaultProps = {

}

const modalActions = { create: "CREATE", update: "UPDATE" };
const defaultBanner = {
  title: "", url: "",  shopify_resource_id: null, index: null, alt: "", url_web: "", b2b_url: "", b2b_alt: "",
}

const ResourceTableForm = (props) => {
  const { record } = props;
  const [open, setOpen] = useState(false);

  const handleRemove = (item, index, renderProps) => {
    const currentRows = List(renderProps.values.resource_table_rows); // array
    const newRows = currentRows.set(index, { ...item, _destroy: true }).toJS(); // update on index and add _destroy flag for rails
    renderProps.setFieldValue("resource_table_rows", newRows);
  }

  const handleAddNew = (values, arrayHelpers, arrayIndex = null) => {
    if(arrayIndex === null) { // just push
      const currentItems = values.resource_table_rows;
      let currentPosition = 0; // if none
      if(!!currentItems){
        currentPosition = currentItems.length; // Consider destroyed ones
      }
      arrayHelpers.push({
        position: currentPosition + 1,
        values: [],
      })
    }
    else{ // insert into specific position
      arrayHelpers.insert(arrayIndex + 1, {
        position: arrayIndex + 1,
        values: [],
      });
    }
  };

  // Translate attributes and insert images
  const buildValuesForSubmit = (values, formikBag) => {
    console.log("VALUES", values);
    const rowsWithPositions = !values.resource_table_rows ? [] : values.resource_table_rows.map((row, index) => ({
      ...row,
      position: index + 1, // Format position here to ensure position is right and uniq for each item (as handleAddNew with specific position might set a repeated position)
    }));

    return {
      resource_table_rows_attributes: rowsWithPositions,
      ...values
    }
  }

  // action UP or DOWN (TODO use named params {} )
  const handleChangePosition = (tableRow, index, action = "UP", renderProps) => {
    const currentRows = List(renderProps.values.resource_table_rows);
    const delta = action == "UP" ? -1 : 1;
    const newIndexPosition = index + delta;

    const currentRowInPosition = currentRows.get(newIndexPosition); // the row which will exchange places with provided item

    let newRows = currentRows.set(newIndexPosition, { ...tableRow }); // set item with new index (for re-render)
    newRows = newRows.set(index, { ...currentRowInPosition }) // on item's original position set the item that was on new position (up or down)
    renderProps.setFieldValue("resource_table_rows", newRows.toJS()); // exchange places and update position values.
  }

  return (
    <PolarisFormProvider
      title={ I18n.t("activerecord.models.resource_table.one") }
      defaultValues={ record }
      submitURL={ props.submitURL }
      submitMethod={  props.method || "POST" }
      pickValuesCallback={ buildValuesForSubmit }
      pageProps={{
        breadcrumbs: [{content: I18n.t("actions.back"), url: '/resource_tables'}]
      }}
    >
      { (renderProps) => 
        <div>
          <Card title="Información General" sectioned>
            <TableForm 
              errors={ renderProps.errors } 
              values={ renderProps.values } 
              handleChange={ renderProps.handleChange } 
            />
          </Card>

          <FieldArray 
            name="resource_table_rows"
            render={(arrayHelpers) => (
              <Card title="Contenido" sectioned
                actions={[
                  { content: "Agregar Fila", onAction: () => handleAddNew(renderProps.values, arrayHelpers),
                    disabled: renderProps.values.columns <= 0 },
                ]}
              >
                <div>
                  <PolarisLabel value={ tAttribute("resource_table", "columns") } />
                  <TagsInput
                    value={ renderProps.values.columns }
                    onlyUnique
                    addKeys={[188, 9, 13]}
                    inputProps={{
                      placeholder: "EUR, USA, Mujer USA, etc."
                    }}
                    onChange={ (data) => renderProps.handleChange(data, "columns") } 
                  />
                </div>

                <TableRowsForm
                  headings={ renderProps.values.columns }
                  tableRows={ renderProps.values.resource_table_rows || [] }
                  handleChange={ renderProps.handleChange }
                  onAddNew={ (rowIndex) => handleAddNew(renderProps.values, arrayHelpers, rowIndex) }
                  onRemoveItem={ (item, index) => handleRemove(item, index, renderProps) }
                  onChangePosition={ (item, index, action) => handleChangePosition(item, index, action, renderProps)  }
                />
              </Card>
            )}
          >
          </FieldArray>

          <FormPageActions
            onPrimaryAction={ renderProps.handleSubmit }
            deleteURL={ props.destroyURL }
            loading={ renderProps.loading }
            disabled={ !renderProps.isValid }
          />
        </div>
      }
    </PolarisFormProvider>
  )
};

ResourceTableForm.propTypes = propTypes;
ResourceTableForm.defaultProps = defaultProps;

export default ResourceTableForm;